// extracted by mini-css-extract-plugin
export var dropdownButton = "_39-0";
export var fullWidthDropdownButton = "_39-1";
export var icon = "_39-3";
export var iconPlaceholder = "_39-2";
export var menuItemRow = "_39-9";
export var separator = "_39-e";
export var shortcutContainer = "_39-7";
export var shortcutContainerFilled = "_39-8";
export var shortcutIconLg = "_39-6";
export var shortcutIconMd = "_39-5";
export var shortcutIconSm = "_39-4";
export var submenuChevron = "_39-d";
export var submenuDropdown = "_39-a";
export var submenuTriggerRow = "_39-b";
export var submenuTriggerRowOpen = "_39-c";